export const SET_SETTINGS_SUCCESS = "SET_SETTINGS_SUCCESS";
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS";
